import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/bootstrap-4";
import { useTranslation } from "react-i18next";
import { MouseEventHandler, useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import BeelditFileInput from "@beeldit/core/components/BeelditFileInput";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => MouseEventHandler;
  backendFormErrors: any;
}

function InvoiceAccountForm(props: Prop) {
  const { formRef, onSubmit, context } = props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});

  const translations = {
    fiscal_name: t("fiscal_name"),
    fiscal_first_surname: t("fiscal_first_surname"),
    last_surname: t("last_surname"),
    fiscal_address: t("fiscal_address"),
    fiscal_number: t("fiscal_number"),
    fiscal_zip: t("fiscal_zip"),
    fiscal_city: t("fiscal_city"),
    fiscal_province: t("fiscal_province"),
    fiscal_country_code: t("fiscal_country_code"),
    is_legal_entity: t("is_legal_entity"),
    company_logo: t("company_logo"),
    phone: t("phone"),
    email: t("email"),
    additional_information: t("additional_information"),
    bank_information: t("bank_information"),
    entity_type: t("entity_type"),
    entity_id: t("entity_id"),
    address_2: t('address_2'),
  };

  let schema: any = {
    type: "object",
    // required: ['minutes', 'customer_id', 'task', 'date', 'report_id'],
    properties: {
      fiscal_name: {
        type: "string",
        title: translations.fiscal_name,
      },
      fiscal_first_surname: {
        type: ["string", "null"],
        title: translations.fiscal_first_surname,
      },
      fiscal_last_surname: {
        type: "string",
        title: translations.last_surname,
        show: false
      },
      fiscal_number: {
        type: ["string", "null"],
        title: translations.fiscal_number,
      },
      fiscal_address: {
        type: "string",
        title: translations.fiscal_address,
      },
      address_2: {
        type: ["string", "null"],
        title: translations.address_2
      },
      fiscal_zip: {
        type: ["string", "null"],
        title: translations.fiscal_zip,
      },
      fiscal_city: {
        type: ["string", "null"],
        title: translations.fiscal_city,
      },
      fiscal_province: {
        type: ["string", "null"],
        title: translations.fiscal_province,
      },
      fiscal_country_code: {
        type: ["string", "null"],
        title: translations.fiscal_country_code,
      },
      // fiscal_country_code: {
      //   type: "string",
      //   title: translations.fiscal_country_code,
      //   default: "ES",
      //   oneOf: [
      //     {
      //       const: "ES",
      //       title: "Spain",
      //     },
      //     {
      //       const: "IT",
      //       title: "Italy",
      //     },
      //   ],
      //   show: false
      // },
      is_legal_entity: {
        type: "boolean",
        title: translations.is_legal_entity,
        show: false
      },
      phone: {
        type: "string",
        title: translations.phone,
        show: false
      },
      email: {
        type: "string",
        title: translations.email,
        show: false
      },
      company_logo: {
        type: "array",
        title: translations.company_logo,
        items: {
          type: "object",
          properties: {
            filename: { type: "string", title: "filename" },
            url: { type: "string", title: "url" },
          },
        },
        show: false
      },
      additional_information: {
        type: "string",
        title: translations.additional_information,
        format: "textarea",
        show: false
      },
      bank_information: {
        type: "string",
        title: translations.bank_information,
        format: "textarea",
        show: false
      },
      // entity_type: {
      //   type: "string",
      //   title: translations.entity_type,
      //   default: "commerce",
      //   oneOf: [
      //     {
      //       const: "commerce",
      //       title: "Commerce",
      //     },
      //     {
      //       const: "customer",
      //       title: "Customer",
      //     },
      //   ],
      //   show: false
      // },
      // entity_id: {
      //   type: "integer",
      //   title: translations.entity_id, //
      //   show: false
      // },
    },
  };
  const uiSchema: UiSchema = {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    company_logo: {
      "ui:widget": "file-input",
    },
  };
  const customWidgets = {
    ...widgets,
    ...{ "file-input": BeelditFileInput },
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  return (
    <JSONSchemaForm
      noHtml5Validate
      showErrorList={false}
      ref={formRef}
      schema={finalSchema}
      uiSchema={uiSchema}
      widgets={customWidgets}
      formData={element}
      validator={validator}
      onChange={handleChange}
      onSubmit={onSubmit}
      onError={log("errors")}
      extraErrors={backendFormErrors}
    />
  );
}

export default InvoiceAccountForm;
